import React, { Component } from 'react'
import _ from 'lodash'

function withInfiniteScrolling(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props)
      this.state = { items: (props.data && props.data.contentData) || [], initialHeight: null }
      this.moreToLoad = true
      this.handleScroll = this.handleScroll.bind(this);
    }
  
    componentDidMount() {
      window.addEventListener('scroll', _.debounce(this.handleScroll, 300))
      this.setState({ initialHeight: window.document.body.clientHeight }, () => {
        // 1. load initial data if it doesn't come from props or
        // 2. load additional data if the content hasn't reach the end of the page yet
        if (!this.hasContentReachedBottom()) {
          if (!this.state.items.length) {
            this.loadData()
          } else {
            this.handleScroll()
          }
        }
      })
    }

    loadData() {
      this.setState({ fetching: true }, () => {
        this.component.fetchData()
        .then(res => {
          let items = this.state.items
          if (res.length > 0) {
            this.setState({ items: items ? items.concat(res) : res })
          } else {
            this.moreToLoad = false
          }
        })
        .then(() => this.setState({ fetching: false }))
      })
    }

    hasContentReachedBottom() {
      let wrapper = this.wrapper.clientHeight
      let body = this.state.initialHeight
      return body - wrapper < 0
    }

    handleScroll() {
      if ((this.moreToLoad === false) || this.state.fetching || !this.isBottomOfPage()) return 
      this.loadData()
    }

    isBottomOfPage() {
      const windowHeight = window.innerHeight
      const body = window.document.body
      const html = window.document.documentElement
      const docHeight = Math.max(
        body.scrollHeight, 
        body.offsetHeight,
        html.clientHeight, 
        html.scrollHeight, 
        html.offsetHeight
      )
      const windowBottom = windowHeight + window.pageYOffset
      return windowBottom >= docHeight - 300		
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.items !== this.state.items && prevState.items.length !== 0) {
        if (!this.hasContentReachedBottom()) {
          this.loadData()
        }
      }
    }
 
    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
      return (
        <div ref={el => this.wrapper = el}>
          <WrappedComponent 
            setWrappedState={this.setState.bind(this)}
            ref={el => this.component = el} 
            {...this.props} 
            {...this.state} 
          />
        </div>
      )
    }
  }
}

export default withInfiniteScrolling